/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'licensing-page';
const prefix = `${moduleName}.${componentName}`;

export const cloudLicensingLabel = `${prefix}.cloudLicensingLabel`;
export const failedToRefreshLicensesError = `${prefix}.failedToRefreshLicensesError`;
export const onPremLicensingServiceLabel = `${prefix}.onPremLicensingServiceLabel`;
export const licensesHeader = `${prefix}.licensesHeader`;
export const defaultApiErrorMessage = `${prefix}.defaultApiErrorMessage`;

export const ENGLISH = {
    [cloudLicensingLabel]: 'Cloud Licensing',
    [failedToRefreshLicensesError]: 'Failed to refresh licenses. Please try again.',
    [onPremLicensingServiceLabel]: 'On-prem License Hub',
    [licensesHeader]: 'Licenses',
    [defaultApiErrorMessage]: 'An error occurred. Please try again.',
};
